import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";
import { Event } from "consumerhouse-shared";

const Title = styled.span`
    font-weight: bold;
    font-size: 1.1em;
    padding: 0.6em 1em;
`;

const Container = styled.div`
    border-radius: 1em;
    background: #0001;
    display: inline-flex;
    flex-direction: column;
    max-width: 425px;
    overflow: hidden;
`;

const InnerContainer = styled.div`
    padding: 1em;
    background: #0001;
`;

const Description = styled.p`
    font-size: 0.8em;
    margin: 0em 0;
`;

const Locations = styled.p`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

type EventCardProps = {
    event: Event;
    style?: React.CSSProperties;
    className?: string;
    children?: React.ReactNode;
};

export function EventCard(props: EventCardProps) {
    return (
        <Container style={props.style} className={props.className}>
            <Title>{props.event.title}</Title>
            <InnerContainer>
                {props.event.description && <Description>{props.event.description}</Description>}
                {props.event.locations && (
                    <Locations>
                        <strong>{props.event.locations.length}</strong>&nbsp;
                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                        &nbsp;
                        {props.event.locations!.map((location) => location.address).join(", ")}
                    </Locations>
                )}
                {props.children}
            </InnerContainer>
        </Container>
    );
}
